var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('polyline',{attrs:{"points":"19.7,50.1 39.6,70.1 79.5,30.2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M49.6,2.3c26.4,0,47.9,21.4,47.9,47.9S76,98,49.6,98S1.7,76.5,1.7,50.1S23.1,2.3,49.6,2.3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }